export const SIDEBAR_ID = 'sidebar';
//# sourceMappingURL=constants.js.map
// @zapier/universal-layout@12.0.37 (fb08e5a7f)
